import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=233df409&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('233df409')) {
      api.createRecord('233df409', component.options)
    } else {
      api.reload('233df409', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=233df409&", function () {
      api.rerender('233df409', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N6jo8SCr4F4R/JS/comp/ImgFallback.vue"
export default component.exports